import { AuthOptions } from "../../models/page";
import { ReactElement, useEffect } from "react";
import { useRouter } from "next/router";
import { useAppSelector } from "../../utils/hooks/store";
import {
  ACTION_QUERY_KEY,
  ACTION_QUERY_SIGN_UP,
  SIGN_IN_MODE,
  SIGN_UP_MODE,
} from "../Authentication/constants";
import LoadingIcon from "../common/LoadingIcon";
import Authentication from "../Authentication";
import _ from "lodash";
import { ADMIN_GROUP } from "../../utils/group";
import FourOhFour from "../../pages/404";
import { useLoadAuth } from "../../utils/hooks/auth";

export default function Authorization({
  authOptions,
  children,
}: {
  authOptions?: AuthOptions;
  children: ReactElement;
}) {
  const loadAuth = useLoadAuth();
  const router = useRouter();
  const {
    loading,
    signedIn,
    groups: usersGroups,
  } = useAppSelector((state) => state.auth);
  const authAction = router.query[ACTION_QUERY_KEY];
  const initialAuthMode =
    authAction == ACTION_QUERY_SIGN_UP
      ? SIGN_UP_MODE
      : authOptions?.defaultAuthMode || SIGN_IN_MODE;

  useEffect(() => {
    if (!signedIn) {
      void loadAuth();
    }
  }, [loadAuth, signedIn]);

  if (authOptions === undefined) {
    return children;
  }

  if (
    authOptions.allowUnauthenticatedIf &&
    authOptions.allowUnauthenticatedIf(router)
  ) {
    return children;
  }

  if (loading) {
    return <LoadingIcon text={"Authenticating"} />;
  }
  if (!signedIn) {
    const authentication = (
      <Authentication
        initialAuthMode={initialAuthMode}
        allowPasskeys={authOptions.allowPasskeys}
      />
    );

    return (
      <>
        {authOptions.AuthContainer !== undefined ? (
          <authOptions.AuthContainer>
            {authentication}
          </authOptions.AuthContainer>
        ) : (
          authentication
        )}
      </>
    );
  }

  if (authOptions.requiredGroups) {
    if (!_.includes(usersGroups, ADMIN_GROUP)) {
      for (const requiredGroup of authOptions.requiredGroups) {
        if (!_.includes(usersGroups, requiredGroup)) {
          return <FourOhFour />;
        }
      }
    }
  }

  return children;
}
